import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ConfigProvider } from "../../../config-provider.service";
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { OrganizationsNavigationProvider } from '../../../organizations/providers/navigation-provider';
import { CurrentUser } from '../../../common/providers/current-user';
import { AthletesProvider } from '../../../athletes/providers/athletes-provider';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { CommunicationsProvider } from '../../providers/communications-provider';
import { CommunicationRights } from '../../providers/communication-rights';
import { Observable, of, Subscription } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { map, tap } from 'rxjs/operators';
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { LowerCasePipe, NgForOf, NgIf, SlicePipe } from "@angular/common";
import { MatIconButton, MatMiniFabButton } from "@angular/material/button";
import { MatFormField, MatInput } from "@angular/material/input";
import { MatIcon } from "@angular/material/icon";
import { MatTooltip } from "@angular/material/tooltip";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { EmojifyPipe } from "../../../chat/pipe/emojify.pipe";
import { DateClosestPipe } from "../../../common/pipes/date-closest";
import { User } from "../../../common/models/user";
import { AppDatePipe } from "../../../common/pipes/app-date";

@Component({
  selector: 'communication-box',
  providers: [],
  styleUrls: ['./communication-box.scss'],
  standalone: true,
  imports: [
    RouterLink,
    ReactiveFormsModule,
    NgForOf,
    NgIf,
    MatMiniFabButton,
    MatIconButton,
    MatInput,
    MatFormField,
    MatIcon,
    MatTooltip,
    MatProgressSpinner,
    TranslateModule,
    LowerCasePipe,
    SlicePipe,
    EmojifyPipe,
    DateClosestPipe,
    AppDatePipe,
  ],
  templateUrl: './communication-box.component.html'
})
export class CommunicationBoxComponent implements AfterViewInit, OnDestroy {

  public readonly OBSERVATION_MAX_LENGTH: number = 5000;
  public isLoading = false;
  public currentLang: string;

  @Input()
  public organization: Organization = {} as Organization;

  @Input()
  public athleteUser: User = {} as User;

  // public rights: OrganizationRights = new OrganizationRights(this._utils);
  public rights: CommunicationRights = new CommunicationRights(this._utils);

  public observationForm = new FormControl('', [Validators.required]);

  public observations$: Observable<any[]> = new Observable<any[]>();
  public lastObservation$: Observable<any> = new Observable<any>();
  public observations: any[] = [];

  private subscriptions: Subscription[] = [];

  constructor(
    public conf: ConfigProvider,
    public currentUser: CurrentUser,
    private _translater: TranslateService,
    private _toaster: MatSnackBar,
    private _route: ActivatedRoute,
    private _utils: UtilsProvider,
    private ts: TranslateService,
    private _organizationNavigation: OrganizationsNavigationProvider,
    private _athletesProvider: AthletesProvider,
    private _currentUserRoles: CurrentUserRolesProvider,
    private communicationsProvider: CommunicationsProvider,
  ) {
    this.currentLang = ts.currentLang;
  }

  public ngOnInit() {
    this.observations$ = this.communicationsProvider.getObservations(this.organization!, this.athleteUser.athlete!).pipe(
      tap((observations) => {
        this.observations = observations;
      })
    );

    // Directly subscribe to observations$ to handle the emission
    this.subscriptions.push(
      this.observations$.subscribe({
        next: (observations) => {
          this.observations = observations;
          // Optionally, if only needed once, you can set lastObservation here:
          this.lastObservation$ = of(observations[0]); // Use of `of` to make it an observable if needed
        },
        error: (error) => {
          console.error('Error fetching observations:', error);
        },
      })
    );

    // If lastObservation needs to be a live updating observable linked to observations$
    this.lastObservation$ = this.observations$.pipe(
      map(observations => observations[0])
    );
  }

  public ngAfterViewInit() {}

  public ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  public onNewObservationClicked() {
    if (this.observationForm.valid) {
      const message = this.observationForm.value;
      this.communicationsProvider.saveObservation(
        this.organization!,
        this.athleteUser.athlete!,
        { message: message }
      ).subscribe((observation) => {
        this.observations$.subscribe();
        this.observationForm.reset('');
      });
    }
  }
}
